import { render, staticRenderFns } from "./SpreadViewerOptions.vue?vue&type=template&id=07da3332"
import script from "./SpreadViewerOptions.vue?vue&type=script&lang=js"
export * from "./SpreadViewerOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07da3332')) {
      api.createRecord('07da3332', component.options)
    } else {
      api.reload('07da3332', component.options)
    }
    module.hot.accept("./SpreadViewerOptions.vue?vue&type=template&id=07da3332", function () {
      api.rerender('07da3332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/SpreadViewerOptions.vue"
export default component.exports